'use client';

import { ThemeProvider } from 'next-themes';
import { ReactNode, useEffect } from 'react';

/**
 * Client-side wrappers shared by every route: theme management (drives the
 * `[data-theme]` attribute the ported stylesheet keys off of) and AOS
 * scroll-animation initialization.
 */
export function Providers({ children }: { children: ReactNode }) {
  useEffect(() => {
    let mounted = true;
    import('aos').then((AOS) => {
      if (mounted) AOS.default.init();
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <ThemeProvider attribute="data-theme" defaultTheme="dark" enableSystem={false}>
      {children}
    </ThemeProvider>
  );
}
